import { MoneyMessage } from '../../../../types/MoneyMessage';
import { PaymentTermReference } from '../../../../types/PaymentTermReference';
import { RequestForQuoteMessage } from '../../../../types/RequestForQuoteMessage';
import { SurchargeType } from '../../../../types/SurchargeType';
import { OfferState } from '../../../offer/model/OfferState';
import { PackType } from '../../models/ItemModel';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

interface ItemRequestMessage {
    productId: string;
    price?: MoneyMessage;
    units: number;
    unit: string;
    unitSize: number;
    packType: PackType;
    volume: number;
    deleted: boolean;
}

interface SurchargeRequestMessage {
    name: string;
    surchargeType: SurchargeType;
    value: MoneyMessage;
    deleted: boolean;
}

interface SamplekitRequestMessage {
    name: string;
    quantity: number;
    value?: MoneyMessage;
    deleted: boolean;
}

interface OfferRequestMessage {
    state: OfferState;
    vesselId: string;
    portId: string;
    dateDelivery: string;
    noticeDays?: number;
    paymentTermReference?: PaymentTermReference;
    paymentTermReferenceDays?: number;
    supplyMode: string;
    vendorReference?: string;
    items: ItemRequestMessage[];
    surcharges?: SurchargeRequestMessage[];
    samplekits?: SamplekitRequestMessage[];
}

interface CreateAdditionalOfferParams {
    requestForQuoteId: string;
    offer: OfferRequestMessage;
}

interface CreateAdditionalOfferResponse {
    id: string;
}

export const createAdditionalOffer = async ({
    requestForQuoteId,
    offer,
}: CreateAdditionalOfferParams): Promise<CreateAdditionalOfferResponse> => {
    const response = await authorizedAxiosInstance.post(`/v1/request-for-quotes/${requestForQuoteId}/quote`, offer);

    return response.data;
};

interface MarkRfqReadParams {
    rfqId: string;
    read: boolean;
}

export const markRfqRead = async ({ rfqId, read }: MarkRfqReadParams): Promise<RequestForQuoteMessage> => {
    const response = await authorizedAxiosInstance.put<RequestForQuoteMessage>(
        `/v1/request-for-quotes/${rfqId}/read`,
        null,
        {
            params: { read },
        }
    );

    return response.data;
};

interface DeclineRfqParams {
    id: string;
    cancelReason?: string;
}

export const declineRfq = async ({ id, cancelReason }: DeclineRfqParams): Promise<RequestForQuoteMessage> => {
    const trimmedCancelReason = cancelReason?.trim();
    const response = await authorizedAxiosInstance.put(`/v1/request-for-quotes/${id}/decline`, null, {
        params: trimmedCancelReason ? { cancelReason: trimmedCancelReason } : undefined,
    });

    return response.data;
};
